import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, HelpCircle, AlertTriangle } from 'lucide-react';
export function PainSection() {
  return <section className="bg-white" data-id="element-54">
      {/* Agitation Part */}
      <div className="py-20 container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-56">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-57">
            ¿Te pasa esto?
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-lg text-gray-600 mb-8" data-id="element-58">
            <span className="bg-red-50 text-red-700 px-4 py-2 rounded-lg font-medium" data-id="element-59">
              Intentas hacer esquejes
            </span>
            <span className="text-gray-400 hidden md:block" data-id="element-60">→</span>
            <span className="md:hidden" data-id="element-61">↓</span>
            <span className="bg-red-50 text-red-700 px-4 py-2 rounded-lg font-medium" data-id="element-62">
              Sigues consejos
            </span>
            <span className="text-gray-400 hidden md:block" data-id="element-63">→</span>
            <span className="md:hidden" data-id="element-64">↓</span>
            <span className="bg-red-50 text-red-700 px-4 py-2 rounded-lg font-medium" data-id="element-65">
              Pruebas métodos
            </span>
          </div>

          <p className="text-2xl font-semibold text-gray-800 mb-12" data-id="element-66">
            ...y aun así no prosperan.
          </p>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-67">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center justify-center gap-2" data-id="element-68">
              <HelpCircle className="w-6 h-6 text-[#4a7c2c]" data-id="element-69" />
              No sabes:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 text-left max-w-2xl mx-auto" data-id="element-70">
              {['Si cortar o esperar', 'Si regar o no', 'Si el problema es el sustrato', 'Si es el clima o eres tú'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-71">
                  <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-72" />
                  <span className="text-gray-700" data-id="element-73">{item}</span>
                </div>)}
            </div>
            <p className="mt-8 text-lg font-medium text-gray-600" data-id="element-74">
              Mientras dudas, las plantas no avanzan.
            </p>
          </div>
        </div>
      </div>

      {/* The Real Problem - Dark Section */}
      <div className="bg-[#2d5016] py-20 text-white" data-id="element-75">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
          <div className="max-w-4xl mx-auto" data-id="element-77">
            <div className="text-center mb-12" data-id="element-78">
              <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-79">
                El problema no eres tú
              </h2>
              <p className="text-xl text-[#6b9d3e] font-medium" data-id="element-80">
                El problema es cómo se explica el proceso.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-81">
              {[{
              title: 'Información desordenada',
              desc: 'La mayoría de los consejos están dispersos y se contradicen.'
            }, {
              title: "Falta el 'Cuándo' y 'Por qué'",
              desc: 'Te dicen qué hacer pero no te explican el momento exacto.'
            }, {
              title: 'No pensado para tu clima',
              desc: 'Consejos genéricos que no funcionan en nuestro entorno.'
            }, {
              title: 'Te obliga a improvisar',
              desc: 'Sin un paso a paso claro, terminas adivinando.'
            }].map((point, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10" data-id="element-82">
                  <AlertTriangle className="w-8 h-8 text-[#6b9d3e] mb-4" data-id="element-83" />
                  <h3 className="text-lg font-bold mb-2" data-id="element-84">{point.title}</h3>
                  <p className="text-gray-300" data-id="element-85">{point.desc}</p>
                </motion.div>)}
            </div>

            <div className="text-center mt-12" data-id="element-86">
              <p className="text-2xl font-light italic opacity-90" data-id="element-87">
                "Y ahí aparecen los errores."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}